import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message } from "antd";
import { DeleteFilled, EyeFilled } from "@ant-design/icons";
import { get, del } from "../../../services";
import Modal from "./modal";

const Admintable = () => {
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const [selectedDetailRecord, setSelectedDetailRecord] = useState({});
  const limit = 10;

  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/property/enquiry/getEnquiries?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/property/enquiry/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.enquiries?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, enquiries: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  // Table Columns
  const columns = [
    {
      title: "Sr",
      dataIndex: "",
      key: "sr",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Phone",
      key: "phone",
      dataIndex: "phone",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Status",
      render: (data) => (
        <Space size="middle">{data?.propertyId[0]?.status}</Space>
      ),
    },
    {
      title: "Type",
      key: "",
      dataIndex: "",
      render: (data) => (
        <Space size="middle">{data?.propertyId[0]?.type}</Space>
      ),
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            <EyeFilled
              onClick={() => {
                showModal();
                setSelectedDetailRecord(data);
              }}
            />
          </div>
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer delete-icon-admin" />
              </Popconfirm>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="header4">
        <h3>Property Inquiries</h3>
      </div>
      {/* Modal */}
      <Modal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        selectedDetailRecord={selectedDetailRecord}
      />
      {/* table */}
      <Table
        columns={columns}
        dataSource={adminData?.enquiries}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={adminData?.totalPages}
        onChange={(e) => {
          setCurrentPage(e);
          getAllAdmins(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Admintable;
